import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { ResizeDetectionService } from '../../services/resize-detection.service';
import { BlogService } from '../../services/blog/blog.service';
import { BlogModel } from '../../models/blog/blog-model';

@Component({
    selector: 'app-blog',
    templateUrl: './blog.component.html',
    styleUrls: ['./blog.component.scss']
})
export class BlogComponent {
    tabItems = ['All', 'Health & Nutrition', 'Recipes', 'Fitness', 'Lifestyle'/*, 'Supplements'*/];
    selectedMasterTab: string | null = 'All';
    blogsModel: BlogModel[] = [];
    allBlogsModel: BlogModel[] = [];
    
    isTablet: boolean = false;
    isMobile: boolean = false;
    isDesktop: boolean = false;
    constructor(private router: Router,
        private sizedetection: ResizeDetectionService,
        private blogService: BlogService) { }
    
    mouseEnter(item: any) {
        item.is_hover = true;
    }
    mouseLeave(item: any) {
        item.is_hover = false;
    }

    ngOnInit() {
        if (localStorage.getItem('cookie')) {
            this.cookiePopupVisibility = false;
        } else this.cookiePopupVisibility = true;
        this.sizedetection.refreshSize();
        this.sizedetection.sizeCondition$.subscribe(data => {
            this.isDesktop = data.isDesktop;
            this.isTablet = data.isTablet;
            this.isMobile = data.isMobile;
        });
        this.getBlogs();
    }

    getBlogs(){
        this.blogService.getBlogs().subscribe((response) => {
            response.body.data.forEach((item: any) => {
                var blogModel = new BlogModel();
                blogModel.id = item.id;
                blogModel.title = item.title;
                blogModel.titleImage = item.title_image;
                blogModel.content = item.content;//blogModel.RemoveHtmlTags(item.content);
                blogModel.content_substring = blogModel.RemoveHtmlTags(item.content).length>200 ? blogModel.RemoveHtmlTags(item.content).substring(0, 200) : blogModel.RemoveHtmlTags(item.content);
                blogModel.date = item.date;
                blogModel.hashtags = item.hashtags ? item.hashtags : 'null';
                blogModel.is_hover = false;
                this.blogsModel.push(blogModel);
            });
            this.allBlogsModel = this.blogsModel;
            //console.log(this.allBlogsModel);
        });
    }
    navigateToBlogDetail(item: any) {
        this.router
            .navigate(['/blogDetail'], { queryParams: item })
            .then(() => { })
            .catch(() => { });
    }

    filterBlogs(selectedMasterTab:any) {
        //console.log(selectedMasterTab);
        this.selectedMasterTab = selectedMasterTab;
        if (selectedMasterTab != 'All')
        this.blogsModel = this.allBlogsModel.filter((x:any)=>x.hashtags.includes(selectedMasterTab));
        else this.blogsModel = this.allBlogsModel;
    }

    formatDate(dateS: string) {
        let date = new Date(dateS);
        return (date.getDate().toString().length==1 ? ("0"+date.getDate().toString()) : date.getDate().toString()) + "/" + ((date.getMonth()+1).toString().length==1 ? ("0"+(date.getMonth()+1).toString()): (date.getMonth()+1).toString()) + "/" + date.getFullYear().toString()
    }

    
    cookiePopupVisibility: boolean = false;
    customCookiePopupVisibility: boolean = false;
    acceptCookie() {
        localStorage.setItem('cookie', "1");
        this.cookiePopupVisibility = false;
    }
    customizeCookie() {
        this.cookiePopupVisibility = false;
        this.customCookiePopupVisibility = true;
    }
    rejectCookie() {
        this.cookiePopupVisibility = false;
    }
    acceptCookieOpen() {
        localStorage.setItem('cookie', "1");
        this.customCookiePopupVisibility= false;
    }
    customizeCookieOpen() {
        localStorage.setItem('cookie', "1");
        this.customCookiePopupVisibility = false;
    }
    rejectCookieOpen() {
        this.customCookiePopupVisibility = false;
    }
}
